import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const maritalStatus: AnswerPathTreeNode = { path: 'maritalStatus', nodeId: NodeIds.insuredMaritalStatus };
